import { ComponentProps } from "react";
import Card from "@particles/card/Card";
import PodcastsKeywordsDetailsCard from "@routes/Podcasts/PodcastsPage/components/PodcastsKeywordsSectionStories/PodcastsKeywordsDetailsCard";
import PodcastsSectionStoriesCard from "@routes/Podcasts/PodcastsPage/components/PodcastsKeywordsSectionStories/PodcastsSectionStoriesCard";
import { PodcastKeywordData } from "@routes/Podcasts/PodcastsPage/utils/types";
import { cn } from "@util/helpers";

type PodcastsKeywordStoriesProps = {
  /** The props for each podcast story card */
  cardProps: ComponentProps<typeof Card>[];
  /** Details about the podcast keyword */
  details: PodcastKeywordData;
  /** Additional class name for the container */
  className?: string;
};

/**
 * Podcasts Keywords Stories Component including Details Card and Story Cards
 */
const PodcastsSectionStories = ({
  cardProps,
  details,
  className,
}: PodcastsKeywordStoriesProps): React.ReactElement => {
  if (cardProps.length === 0) return <></>;

  return (
    <div
      data-testid="podcasts-keywords-stories-component"
      className={cn("mb-10 border-t border-gray-850 pt-4", className)}
    >
      <PodcastsKeywordsDetailsCard details={details} />

      {cardProps.map(
        ({ id, title, link, partnership, updatedTime, displayPaywall }) => (
          <PodcastsSectionStoriesCard
            className={cn(
              "relative my-8",
              "before:absolute before:-bottom-4 before:h-[1px] before:w-full before:bg-gray-175 last:before:hidden"
            )}
            key={`${details.id}-${id}`}
            titleProps={{
              title: title,
              to: link,
              articleId: id.toString(),
            }}
            partenrshipProps={{
              partnership: partnership,
            }}
            timeProps={{
              updated: updatedTime || "",
            }}
            displayPaywall={displayPaywall}
          />
        )
      )}
    </div>
  );
};

export default PodcastsSectionStories;
